const getImageHeight = (width, aspectRatio) =>
  typeof width === 'number' && typeof aspectRatio === 'number'
    ? Math.round(width / aspectRatio)
    : undefined;

export default getImageHeight;
